<table
  mat-table
  [dataSource]="dataSource$ | async"
  matSort
  matSortActive="date"
  matSortDirection="desc"
  matSortDisableClear
  (matSortChange)="sortChange($event)"
  [ngClass]="bpS.isLessMd ? 'ib-mat-table' : ''"
>
  <ng-container
    *ngFor="let column of tableConfig.columns"
    matColumnDef="{{ column.field }}"
  >
    <!-- <mat-header-cell
      *matHeaderCellDef
      [mat-sort-header]="column.sortable ? column.field : null"
      [disabled]="false"
    >
      {{ column.headerTitle }}
    </mat-header-cell> -->
    <th
      mat-header-cell
      *matHeaderCellDef
      ibTableHeadCellAllignment
      [ibTableHeadCellAllignmentType]="column.dataType"
      [mat-sort-header]="column.sortable ? column.field : null"
      [disabled]="column.sortable ? false : true"
      class="{{ column.dataType === DATA_TYPE.NUMBER ? 'text-right!' : '' }}"
    >
      <span>{{ column.headerTitle }}</span>
    </th>
    <td mat-cell *matCellDef="let row">
      <ib-table-cell-content
        [row]="row"
        [column]="column"
        [isMobileView]="bpS.isLessMd"
      ></ib-table-cell-content>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  <tr class="mat-row" *matNoDataRow>
    <td class="mat-cell" colspan="4">{{ 'base.no-data-found' | transloco }}</td>
  </tr>
</table>
<mat-paginator
  #paginator
  pageSize="25"
  [length]="totalItems"
  showFirstLastButtons
  (page)="changePagination($event)"
></mat-paginator>
